module.exports = __webpack_public_path__ + "img/logo-gaig.27f828b7.svg";